import { defaultIfEmpty } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { AppConfigProvider } from '@root/app/app.config.provider';
import { Injectable } from '@angular/core';
import { UnusedAccount } from '@models/unused-account';

@Injectable({
  providedIn: 'root'
})
export class UnusedAccountsService {
  private addUnusedAccEndpoint: string;
  private fetchUnusedAccEndpoint: string;

  public isLoadingUnusedAccounts: boolean = true;

  constructor(private config: AppConfigProvider, private http: HttpClient) {
    this.config.environment.subscribe(env => {
      const environment = env.API.BALANCEAPI;
      this.fetchUnusedAccEndpoint = `${environment}/api/balancesheet/unused`;
      this.addUnusedAccEndpoint = `${environment}/api/balancesheet/addunused`;
    });
  }

  public fetchUnusedAccounts() {
    this.isLoadingUnusedAccounts = true;
    return this.http
      .get<UnusedAccount[]>(this.fetchUnusedAccEndpoint)
      .pipe(defaultIfEmpty([]))
      .toPromise();
  }

  public saveUnusedAccounts(source: UnusedAccount[]) {
    const body = source.filter(acc => acc.AccountNumber && typeof acc.AccountNumber === 'number');
    const mappedBody = this.convertNullsFieldsIntoEmptyStrings(body);
    return this.http.post(this.addUnusedAccEndpoint, mappedBody).toPromise();
  }

  private convertNullsFieldsIntoEmptyStrings(accountsList: UnusedAccount[]): UnusedAccount[] {
    return accountsList.map((acc: UnusedAccount) => ({
      AccountName: acc.AccountName || '',
      AccountNumber: acc.AccountNumber,
      Mnemonic: acc.Mnemonic || ''
    }));
  }
}
